export default { Loading: 'Ładowanie' };
